import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Label } from 'reactstrap';

import { messages } from '../../../../../../_shared/i18n/messages';

import { useFormEditorContext } from '../../../contexts/FormEditorContext';
import { OPTION_EDITOR_FIELDS } from '../../../hooks/useFormEditorData';
import { formFieldOptionDataShape } from '../../../utils/propTypes';

const propTypes = {

	/**
	 * The id of the field.
	 */
	fieldId: PropTypes.string.isRequired,

	/**
	 * The form field option.
	 */
	option: formFieldOptionDataShape.isRequired,

};

const FormEditorFieldOptionLikert = (props) => {

	const { fieldId, option } = props;

	const intl = useIntl();

	const {
		defaultLanguage,
		isEditingDefaultLanguage,
		selectedLanguage,
		actions,
	} = useFormEditorContext();

	// Get the form field option content data for the selected language
	const activeTranslation =
		option[OPTION_EDITOR_FIELDS.CONTENTS].find(
			(content) => content.language === selectedLanguage
		);

	// Get the form field option content data for the default language
	const defaultTranslation =
		option[OPTION_EDITOR_FIELDS.CONTENTS].find(
			(content) => content.language === defaultLanguage
		);

	let placeholderTextForOptionValue =
		intl.formatMessage(messages.TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_OPTION_LIKERT_SCALE);

	// Check if we should show the default translation as the placeholder text
	if (!isEditingDefaultLanguage && (
		defaultTranslation?.[OPTION_EDITOR_FIELDS.LABEL] !==
		option[OPTION_EDITOR_FIELDS.VALUE]
	)) {

		placeholderTextForOptionValue = defaultTranslation?.[OPTION_EDITOR_FIELDS.LABEL];

	}

	let inputTextForOptionValue = activeTranslation?.[OPTION_EDITOR_FIELDS.LABEL];

	if (inputTextForOptionValue === option[OPTION_EDITOR_FIELDS.VALUE]) {
		inputTextForOptionValue = '';
	}

	return (
		<div className="tc-form-editor-field-option form-check">
			<div className="select-input-option-label">
				{`${option[OPTION_EDITOR_FIELDS.VALUE]}.`}
			</div>
			{' '}
			<Label
				for={`${option.id}-label-and-value`}
				hidden>
				{placeholderTextForOptionValue}
			</Label>
			<input
				className="tc-material-input"
				name={`${option.id}-label-and-value`}
				type="text"
				value={inputTextForOptionValue || ''}
				placeholder={placeholderTextForOptionValue}
				onChange={(event) => {

					const newValue = event.target.value;

					// Check if customizing the label text
					if (newValue) {

						actions.options.update(
							fieldId,
							option.id,
							OPTION_EDITOR_FIELDS.LABEL,
							newValue,
						);

					// Otherwise, reset the label text to match the likert scale value
					// i.e. 0, 1, 2, ... , 7, 8, 9
					} else {

						actions.options.update(
							fieldId,
							option.id,
							OPTION_EDITOR_FIELDS.LABEL,
							option[OPTION_EDITOR_FIELDS.VALUE],
						);

					}

				}} />
		</div>
	);

};

FormEditorFieldOptionLikert.propTypes = propTypes;

export default FormEditorFieldOptionLikert;
